






































































































import { AZNCONNECT_API } from "@/services/aznconnect-api";
import { Component, Vue } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import { ActionMethod } from "vuex";
import Clock from "@/components/Clock.vue";
import {
  ApplicationConfiguration,
  AuthenticationConfiguration,
  UserPermissions,
} from "@/types/store";
import LoggedOnComponent from "@/components/zorgID/LoggedOnComponent.vue";
import { SecurityService } from "@/services/SecurityService";
import ApplicationMessageComponent from "@/components/zorgID/ApplicationMessageComponent.vue";
import { EventBus } from "@/event-bus";
import moment from "moment";
import MsalLoginButton from "./components/msal/MsalLoginButton.vue";
import MsalLoggedOnComponent from "./components/msal/MsalLoggedOnComponent.vue";
import { msalService } from "./auth/msalService";
import store from "@/store/index";

@Component({
  components: {
    LoggedOnComponent,
    clock: Clock,
    ApplicationMessageComponent,
    MsalLoginButton,
    MsalLoggedOnComponent,
  },
})
export default class App extends Vue {
  public constructor() {
    super();
    SecurityService.getInstance(); // leave this, this is required to start the signalr connection to the ZorgIDHub
  }

  @Getter("userPermissions")
  userPermissions!: UserPermissions;

  @Getter("showMainMenu")
  showMainMenu!: boolean;

  @Getter("currentCluster", { namespace: "espoed" })
  currentCluster!: string;

  @Getter("currentDepartment", { namespace: "espoed" })
  currentDepartment!: string;

  @Getter("currentType", { namespace: "espoed" })
  currentType!: string;

  @Getter("currentPriority", { namespace: "espoed" })
  currentPriority!: string;

  @Getter("socketIsConnected")
  socketIsConnected!: boolean;

  @Getter("applicationConfiguration")
  applicationConfiguration!: ApplicationConfiguration;

  @Getter("authenticationConfiguration")
  authenticationConfiguration!: AuthenticationConfiguration;

  @Action("loadConfiguration")
  loadConfiguration!: ActionMethod;

  msalLoggedIn: boolean = false;

  created() {
    if (
      store.getters.authenticationConfiguration.authenticationType === "msal"
    ) {
      // auto detect if user already logged in
      this.msalLoggedIn = !!msalService.getAccount();
    }

    this.loadConfiguration()
      .then(response => {
        console.log("Application configuration loaded");
      })
      .catch(function(error) {
        console.log("Error loading application configuration");
        console.error(error);
      });

    EventBus.$on("SecurityService_loggedon_user", () => {
      //trigger on user logon
      this.validateExpirationDate();
    });
  }

  validateExpirationDate() {
    AZNCONNECT_API.get("mandate/ValidateExpirationDate").then(function(
      response,
    ) {
      if (response.data.length > 0) {
        var message = "";
        var mandate = response.data[0];
        var uziNumber = SecurityService.getInstance().uziNumber;

        // The mandate that is about to expire is from the groupowner (equals logged in uzi number)
        if (mandate.GroupOwnerUziNumber == uziNumber) {
          message =
            "Op " +
            moment(String(mandate.ExpirationDate)).format("DD-MM-YYYY") +
            " " +
            "verloopt het 'Professionele Samenvattings' mandaat waarvan u eigenaar bent. " +
            "Gelieve deze groep opnieuw te mandateren indien u wenst dat deze groep in uw naam de " +
            "'Profesionele Sammenvatting' kan blijven gebruiken.";
        }
        // The mandate that is about to expire is assigned to a member and is not the groupowner
        else {
          message =
            "Op " +
            moment(String(mandate.ExpirationDate)).format("DD-MM-YYYY") +
            " verloopt het 'Professionele Samenvattings' mandaat van de " +
            mandate.GroupName +
            " waavan u lid bent. Gelieve uw mandaatgever (" +
            mandate.GroupOwnerFullName +
            ") te vragen uw groep een nieuw mandaat te verstrekken.";
        }

        EventBus.$emit("application_message_component_warning", message, 15000);
      }
    });
  }

  redirectToMandatePage() {
    this.$router.push("/mandate");
  }

  logout() {
    msalService.logout();
  }
}
